import configApi from '../../api/config-api'

const state = {
  config: {},
  policy: {},
}

const mutations = {
  setConfig(state, val) {
    state.config = val
  },
  setPolicy(state, val) {
    state.policy = val
  },
}

const actions = {
  async getConfig({ commit }) {
    commit('app/loading', true, { root: true })
    await configApi.getConfig()
      .then(
        response => {
          commit('setConfig', response.data)
          commit('app/loading', false, { root: true })
        },
        () => {
          commit('app/loading', false, { root: true })
          commit('notifications', { title: 'Error al obtener la información.', variant: 'danger' }, { root: true })
          commit('setShowNotifications', true, { root: true })
        },
      )
  },
  edit({ commit }, { config }) {
    commit('app/loading', true, { root: true })
    configApi.edit(config)
      .then(
        () => {
          commit('notifications', { title: 'Información actualizada con éxito.', variant: 'success' }, { root: true })
          commit('setShowNotifications', true, { root: true })
          commit('app/loading', false, { root: true })
        },
        () => {
          commit('app/loading', false, { root: true })
          commit('notifications', { title: 'Error al actualizar.', variant: 'danger' }, { root: true })
          commit('setShowNotifications', true, { root: true })
        },
      )
  },
  async getPolicy({ commit }) {
    commit('app/loading', true, { root: true })
    await configApi.getPolicy()
      .then(
        response => {
          commit('setPolicy', response.data)
          commit('app/loading', false, { root: true })
        },
        () => {
          commit('app/loading', false, { root: true })
          commit('notifications', { title: 'Error al obtener la información.', variant: 'danger' }, { root: true })
          commit('setShowNotifications', true, { root: true })
        },
      )
  },
  editPolicy({ commit }, config) {
    commit('app/loading', true, { root: true })
    configApi.editPolicy(config)
      .then(
        () => {
          commit('notifications', { title: 'Información actualizada con éxito.', variant: 'success' }, { root: true })
          commit('setShowNotifications', true, { root: true })
          commit('app/loading', false, { root: true })
        },
        () => {
          commit('app/loading', false, { root: true })
          commit('notifications', { title: 'Error al actualizar.', variant: 'danger' }, { root: true })
          commit('setShowNotifications', true, { root: true })
        },
      )
  },
}

const getters = {
  getConfig: state => state.config,
  getPolicy: state => state.policy,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
